<div class="device-list-container">
    <ng-container *ngIf="isBulkEditing">
        <div class="bulk-edit-container">
            <div class="apply-right-container">
                <div class="all-checkbox-container">
                    <mat-checkbox
                        class="checkbox"
                        [checked]="isBulkEditAll"
                        (click)="checkAll(); $event.stopPropagation()" />
                    <div>{{ 'device-list.unit.bulk.all' | translate }}</div>
                </div>
                <app-device-model-dropdown
                    class="column model"
                    [modelOptions]="models"
                    (onModelSelected)="handleBulkModelSelected($event)">
                </app-device-model-dropdown>
                <ng-container *ngIf="showClearButton()">
                    <div class="clear-all" (click)="clearAll()">
                        <mat-icon svgIcon="delete" class="delete-icon icon-margin" />
                        {{ 'device-list.unit.bulk.clear-all' | translate }}
                    </div>
                </ng-container>
            </div>
            <div class="apply-button" [class.applyDisabled]="isApplyDisabled()" (click)="applyBulkEdit()">
                {{ 'device-list.unit.bulk.apply' | translate }}
            </div>
        </div>
    </ng-container>
    <div class="table-row table-header">
        <div class="column unit-no" [class.IoUnit]="isIoDevice()">
            {{
                isIoDevice()
                    ? ('device-list.unit.header.type' | translate)
                    : ('device-list.unit.header.index' | translate: { deviceType })
            }}
        </div>
        <div class="column model" [class.IoModel]="isIoDevice()">
            {{ 'device-list.unit.header.model' | translate }}
        </div>
        <div class="column item-code" [class.IoCode]="isIoDevice()">
            {{ 'device-list.unit.header.item-code' | translate }}
        </div>
        <div class="column description" [class.IoDescription]="isIoDevice()">
            {{ 'device-list.unit.header.description' | translate }}
        </div>
        <div class="column options"></div>
    </div>
    <div *ngFor="let unit of units; index as i" class="table-row" [class.expanded]="isUnitExpanded(unit)">
        <div class="column unit-no semibold" [class.IoUnit]="isIoDevice()">
            <ng-container *ngIf="isBulkEditing">
                <mat-checkbox
                    class="checkbox"
                    [checked]="unit.checked"
                    (click)="checkUnit(unit); $event.stopPropagation()" />
            </ng-container>
            <div>{{ getIndex(unit) }}</div>
        </div>
        <app-device-model-dropdown
            class="column model"
            [class.IoModel]="isIoDevice()"
            [modelOptions]="models"
            [unitModel]="getUnitModel(unit)"
            (onModelSelected)="handleModelSelected($event, unit)">
        </app-device-model-dropdown>

        <div class="column item-code" [class.emptyCell]="!getModelItemCode(unit)" [class.IoCode]="isIoDevice()">
            {{ getModelItemCode(unit) ? getModelItemCode(unit) : '-' }}
        </div>

        <app-description-cell
            class="description"
            [class.IoDescription]="isIoDevice()"
            [description]="getModelDescription(unit)"
            (expandedChange)="setUnitExpanded(unit, $event)"></app-description-cell>

        <div class="column options" #optionsCol>
            <mat-icon svgIcon="more-options" class="icon" (click)="openUnitOptions(unit, i)" />
            <div class="options-container" *ngIf="openedUnitOptions == unit" [style.top]="optionsTop">
                <div class="option-row" (click)="deleteUnit(unit)">
                    <mat-icon svgIcon="delete" class="delete-icon icon-margin" />
                    {{ 'dlg.clear' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
